import { Outlet, Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useCart } from "../../context/CartContext";
import { ShoppingBag, Package } from "lucide-react";
import publicApi from "../../lib/publicApi";

export default function ShopLayout() {
    const { count } = useCart();
    const [store, setStore] = useState({ store_name: "福缘珠宝 FuYuan Jewelry" });
    const nav = useNavigate();

    useEffect(() => {
        publicApi.get("/public/store-info").then(({ data }) => setStore(data)).catch(() => {});
    }, []);

    return (
        <div className="min-h-screen" style={{ background: "linear-gradient(180deg,#FBF7EF 0%,#F5EBD1 100%)" }}>
            <header className="sticky top-0 z-30 backdrop-blur-md bg-white/70 border-b border-gold-200">
                <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
                    <Link to="/shop" className="flex items-center gap-3">
                        <div className="h-9 w-9 rounded-md bg-gold-600 flex items-center justify-center shadow-md shadow-gold-900/10">
                            <Package className="h-4 w-4 text-white" />
                        </div>
                        <div>
                            <div className="text-[10px] tracking-widest uppercase text-gold-700">FuYuan Jewelry</div>
                            <div className="text-sm font-bold text-slate-900 -mt-0.5">{store.store_name}</div>
                        </div>
                    </Link>
                    <div className="flex items-center gap-4">
                        <button
                            data-testid="shop-cart-btn"
                            onClick={() => nav("/shop/checkout")}
                            className="relative inline-flex items-center gap-2 px-3 h-9 rounded-full bg-gold-600 hover:bg-gold-700 text-white text-sm font-medium transition-colors"
                        >
                            <ShoppingBag className="h-4 w-4" />
                            <span>购物车</span>
                            {count > 0 && (
                                <span className="absolute -top-1 -right-1 h-5 w-5 rounded-full bg-red-600 text-white text-[10px] font-bold flex items-center justify-center">{count}</span>
                            )}
                        </button>
                        <Link to="/login" className="text-xs text-gold-700 hover:text-gold-900 hidden sm:block">员工登录</Link>
                    </div>
                </div>
            </header>
            <main className="max-w-6xl mx-auto px-6 py-8">
                <Outlet />
            </main>
            <footer className="py-8 text-center text-xs text-gold-700/70 border-t border-gold-200 mt-12">
                © 2026 FuYuan Jewelry · 福缘珠宝 · 缘起福生 · 智启未来
            </footer>
        </div>
    );
}
